'use strict';
const Backbone = require('backbone');
const PubSub = require('./../PubSub');
const jwt_decode = require('jwt-decode').default;

module.exports = Backbone.Model.extend({
    /**
     * Default values for the model
     */
    defaults: {
        googleClientId: null,
        user: {
            id: ''
        }
    },
    /**
     * Initialize the model
     */
    initialize: function(attrs, options) {
        if( !window.google ) {
            window.onGoogleLibraryLoad = this.onGoogleLoaded.bind(this);
            loadScript('https://accounts.google.com/gsi/client');
        }

    },
    onGoogleLoaded: function() {
        window.google.accounts.id.initialize({
            client_id: this.get('googleClientId'),
            callback: this.onCredentialResponse.bind(this),
            ux_mode: 'popup',
            auto_select: true,
            width: 400,
            logo_alignment: 'center',
            prompt_parent_id: 'g_id_onload'
        })

        this.trigger('prompt');
    },
    onCredentialResponse( response ) {
        const payload = jwt_decode( response.credential );
        this.set({
            user: {
                id: payload.sub,
                name: payload.name,
                email: payload.email
            }
        });

        PubSub.trigger('directRoute','closeCurrentModal');
        PubSub.trigger('authenticated', 'google');
    },


    /**
     * Render a custom Google button
     */
    renderButton: function( element, callback ) {
        callback = callback || function() {};

        window.google.accounts.id.renderButton(
            element,
            { 
                theme: 'filled_blue', 
                size: 'large', 
                type: 'standard',
                click_listener: callback
            }
        );
    },

    /**
     * Signs out the user
     */
    signout: function() {
        window.google.accounts.id.disableAutoSelect();
    },
    /**
     * Clear user object
     */
    clearUserData: function() {
        this.set({
            user: this.defaults.user
        });
    }
});


function loadScript( url, callback ) {
  const script = document.createElement('script');
  script.src = url;
  script.onload = callback;
  document.head.appendChild( script );
}


// WEBPACK FOOTER //
// ./app/scripts/models/google.js